/* src/app/landingpages/product-services/product-services.component.css */
tp-hd {
  display: flex;
  flex-direction: column;
}
.top {
  margin-top: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.top p {
  text-align: left;
  margin: 20px;
  font-size: 16px;
}
.trust-pilot {
  display: flex;
  align-items: center;
}
.trust-pilot img {
  width: 189px;
  height: 83;
}
.nw-strp {
  background-color: #f6f6f7;
  display: flex;
  padding: 20px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.nw-strp-lft {
  display: flex;
  align-items: center;
  gap: 10px;
}
.nw-strp-rgt {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.bk-dm {
  background-color: #2489C6;
  padding: 10px;
  color: #fff;
}
.to-nmt {
  background-color: #007BA7;
  padding: 10px;
  color: #fff;
}
.scroll-anim {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.field {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 300px;
}
.mouse {
  width: 50px;
  height: 90px;
  border: 3px solid #333;
  border-radius: 60px;
  position: relative;
}
.mouse::before {
  content: "";
  width: 12px;
  height: 12px;
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  border-radius: 50%;
  opacity: 1;
  animation: wheel 2s infinite;
  -webkit-animation: wheel 2s infinite;
}
@keyframes wheel {
  to {
    opacity: 0;
    top: 60px;
  }
}
@-webkit-keyframes wheel {
  to {
    opacity: 0;
    top: 60px;
  }
}
.scroll {
  width: 60px;
  height: 60px;
  border: 2px solid #333;
  border-radius: 50%;
  position: relative;
  animation: down 1.5s infinite;
  -webkit-animation: down 1.5s infinite;
}
.scroll::before {
  content: "";
  position: absolute;
  top: 15px;
  left: 18px;
  width: 18px;
  height: 18px;
  border-left: 2px solid #333;
  border-bottom: 2px solid #333;
  transform: rotate(-45deg);
}
@keyframes down {
  0% {
    transform: translate(0);
  }
  20% {
    transform: translateY(15px);
  }
  40% {
    transform: translate(0);
  }
}
@-webkit-keyframes down {
  0% {
    transform: translate(0);
  }
  20% {
    transform: translateY(15px);
  }
  40% {
    transform: translate(0);
  }
}
@keyframes scroll {
  0% {
    height: 40px;
  }
  30% {
    height: 70px;
  }
  60% {
    height: 40px;
  }
}
@-webkit-keyframes scroll {
  0% {
    height: 40px;
  }
  30% {
    height: 70px;
  }
  60% {
    height: 40px;
  }
}
.circle-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  padding-left: 20px;
  padding-right: 20px;
}
.circle {
  width: 110px;
  height: 110px;
  background-color: #f2f2f2;
  border-radius: 50%;
  background-size: cover;
  animation: wave 2s infinite ease-in-out alternate;
}
.circle img {
  width: 100%;
  height: 100%;
}
@keyframes wave {
  0% {
    transform: translateY(0px);
  }
  100% {
    transform: translateY(15px);
  }
}
.top .circle:nth-child(even),
.bottom .circle:nth-child(odd) {
  animation-direction: alternate-reverse;
}
.content {
  margin: 100px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
h2 {
  color: #007BA7;
  font-size: 64px;
}
p {
  font-size: 24px;
  color: #555;
}
.btn {
  width: 300px;
  background: #007BA7;
  color: white;
  padding: 10px 20px;
  border: none;
  font-weight: bold;
  border-radius: 30px;
  cursor: pointer;
  font-size: 18px;
}
.btn:hover {
  background: #0056b3;
}
.info-section {
  background: #007BA7;
  height: 250px;
  display: flex;
  justify-content: center;
  position: relative;
  margin-top: -100px;
  margin-bottom: 50px;
}
.info-box {
  background: #fff;
  padding: 30px;
  width: 70%;
  text-align: center;
  border-radius: 25px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  position: absolute;
  top: -50px;
}
.info-box h3 {
  font-size: 28px;
  color: black;
  font-weight: 600;
}
.info-box p {
  font-size: 24px;
  color: #444;
  margin: 5px 0;
}
.btn3 {
  width: 350px;
  background: #007BA7;
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 30px;
  font-weight: bold;
  cursor: pointer;
  font-size: 18px;
  text-align: center;
  transition: background 0.3s ease-in-out;
}
.btn2 {
  width: 350px;
  background: #007BA7;
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 30px;
  font-weight: bold;
  cursor: pointer;
  font-size: 18px;
  margin-top: 15px;
  transition: background 0.3s ease-in-out;
}
.btn2:hover {
  background: #0056b3;
}
.num-info {
  margin-top: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px;
}
.ni-card {
  width: 400px;
  height: 300px;
  background-color: #FBFBFB;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border-radius: 20px;
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.1);
}
.sub-nic {
  display: flex;
  justify-content: center;
  align-items: center;
}
.ni-card h1 {
  font-size: 72px;
}
.offerings-section {
  margin-top: 50px;
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.offerings-section h1 {
  font-size: 55px;
  font-weight: 400;
}
.underline {
  width: 200px;
  height: 3px;
  background-color: #030303;
}
.carousel {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.slides-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.5s ease-in-out;
}
.slide {
  width: 90%;
  padding: 2rem;
  background-color: #ffffff;
}
.slide-container {
  display: flex;
  gap: 2rem;
  margin-bottom: 2rem;
  background-color: #F6F6F6;
  border-radius: 15px;
}
.div-strp {
  width: 100%;
  height: 10px;
  background-color: #007BA7;
}
.text-content {
  width: 70%;
  margin: 20px;
}
.text-content .title {
  color: #007BA7;
  margin-bottom: 1.5rem;
  font-size: 3rem;
}
.text-content p {
  color: #34495e;
  margin-bottom: 1rem;
  font-size: 18px;
}
.text-content ul {
  list-style-type: disc;
  padding-left: 1.5rem;
  margin-bottom: 2rem;
  margin-top: 20px;
}
.text-content h5 {
  color: black;
  font-size: 2.5rem;
}
.text-content li {
  position: relative;
  margin-left: 20px;
  margin-bottom: 0.5rem;
  font-size: 20px;
  color: #000000;
}
.text-content li::before {
  position: absolute;
  left: 0;
  color: #3498db;
}
.image-content {
  width: 30%;
  display: flex;
  align-items: center;
}
.image-content img {
  width: 100%;
  height: 600px;
  align-self: flex-end;
  border-radius: 0 15px 15px 0;
}
.info-box-container2 {
  display: flex;
  gap: 1.5rem;
  padding: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}
.info-box2 {
  display: flex;
  flex-direction: column;
  background: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  flex: 1;
  min-width: 300px;
  width: 350px;
  max-height: 450px;
}
.mck-cta {
  width: 250px;
  background-color: #007BA7;
  padding: 10px;
  border-radius: 30px;
  color: white;
  text-align: center;
  margin: 20px;
  font-size: 16px;
}
.h-sl2 {
  font-size: 24px;
}
.info-box2 h4 {
  color: #2c3e50;
  margin-bottom: 1rem;
  margin-left: 10px;
}
.ib-head-bx {
  display: flex;
  background-color: #FFBF00;
  border-radius: 15px 15px 0 0;
}
.ib-head-bx h4 {
  color: #fff;
  margin: 10px;
  font-size: 28px;
  font-weight: 600;
}
.info-box2 p {
  font-size: 18px;
  margin-left: 10px;
}
.info-box2 h5 {
  color: black;
  font-size: 22px;
  margin-left: 10px;
  margin-top: 25px;
}
.info-box2 ul {
  margin-top: 20px;
  margin-bottom: 10px;
}
.info-box2 li {
  margin-left: 30px;
  list-style: disc;
  color: black;
  font-size: 20px;
}
.btn:hover {
  background: #2980b9;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3);
}
.navigation-dots {
  position: absolute;
  bottom: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 30px;
}
.dot {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #bdc3c7;
  cursor: pointer;
  transition: all 0.3s ease;
}
.dot.active {
  background-color: #3498db;
  transform: scale(1.2);
}
.dot:hover {
  background-color: #3498db;
}
.rar-section {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.rar-section h1 {
  font-size: 55px;
  font-weight: 400;
  color: black;
}
.underline2 {
  width: 500px;
  height: 2px;
  background-color: black;
}
.rs-sub {
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 25px;
  gap: 100px;
}
.sub-left {
  width: 50%;
  display: flex;
  flex-direction: column;
  padding: 60px;
}
.p-h {
  color: #3C5491;
  font-size: 24px;
  font-weight: bold;
}
.p-d {
  font-size: 18px;
}
.sub-right {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
}
.sub-right img {
  width: 100%;
}
.cta-2 {
  width: 350px;
  background: #007BA7;
  color: white;
  padding: 12px 20px;
  border: none;
  text-align: center;
  border-radius: 30px;
  font-weight: bold;
  cursor: pointer;
  font-size: 18px;
  margin-top: 15px;
  transition: background 0.3s ease-in-out;
}
.ft-sc {
  margin-top: 80px;
  display: flex;
  background-color: #FDFDFD;
  flex-direction: column;
  align-items: center;
  padding: 50px;
}
.ft-sc h1 {
  font-size: 48px;
}
.ft-sc-sub {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 50px;
  gap: 40px;
}
.ft-card {
  background-color: #FBFBFB;
  border-radius: 25px;
  height: 350px;
  width: 400px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.1);
}
.ft-card h3 {
  margin-top: 20px;
  font-size: 28px;
}
.ft-card p {
  max-width: 350px;
  margin-top: 10px;
  font-size: 18px;
}
.ft-card img {
  align-self: flex-end;
  width: 155px;
  margin-right: -25px;
  bottom: 2px;
}
.ct-us {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 50px;
}
.ct-us h1 {
  font-size: 48px;
  font-weight: 400;
  color: #007BA7;
}
.sub-ct-us {
  display: flex;
  gap: 100px;
  margin-top: 50px;
  margin-bottom: 50px;
}
.sub-ct-us img {
  width: 60px;
  height: 60px;
}
.sb-card {
  display: flex;
  gap: 20px;
  padding: 10px;
  border-radius: 20px;
  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.1);
  align-items: center;
  width: 350px;
  cursor: pointer;
}
.txt-ct {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.txt-ct h4 {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
}
.txt-ct p {
  font-size: 24px;
}
@media (max-width: 768px) {
  html {
    font-size: 14px;
  }
  .trust-pilot img {
    width: 150px;
    margin-bottom: 20px;
  }
  .circle-container {
    flex-wrap: wrap;
    gap: 10px;
    padding: 0 10px;
  }
  .circle {
    width: 50px;
    height: 50px;
  }
  .content {
    margin: 100px 0;
    padding: 0 20px;
  }
  h2 {
    font-size: 2.5rem;
    text-align: center;
  }
  .content p {
    font-size: 1.1rem;
    text-align: center;
  }
  .content h3 {
    font-size: 1.5rem;
  }
  .btn {
    width: 100%;
    max-width: 300px;
    border-radius: 30px;
  }
  .info-section {
    height: auto;
    padding: 20px 0;
  }
  .info-box {
    width: 90%;
    position: static;
    margin: -30px auto 0;
    padding: 20px;
  }
  .info-box h3 {
    font-size: 2rem;
  }
  .info-box p {
    font-size: 1rem;
  }
  .num-info {
    flex-direction: column;
    gap: 20px;
    padding: 20px;
  }
  .ni-card {
    width: 100%;
    height: auto;
    padding: 30px 20px;
  }
  .carousel {
    width: 100%;
  }
  .slide-container {
    flex-direction: column;
  }
  .slide {
    width: 100%;
  }
  .text-content,
  .image-content {
    width: 100% !important;
  }
  .image-content img {
    height: 300px;
    border-radius: 15px;
    object-fit: cover;
  }
  .info-box-container2 {
    flex-direction: column;
    align-items: center;
  }
  .info-box2 {
    width: 100%;
    min-width: auto;
  }
  .text-content h5 {
    width: 90%;
  }
  .rs-sub {
    flex-direction: column;
    gap: 20px;
  }
  .sub-left,
  .sub-right {
    width: 100%;
    padding: 20px;
  }
  .sub-right img {
    width: 80%;
  }
  .p-h {
    font-size: 2rem;
  }
  .p-d {
    font-size: 1.5rem;
  }
  .ft-sc-sub {
    flex-direction: column;
    width: 100%;
  }
  .ft-card {
    width: 100%;
    height: auto;
    padding: 25px;
  }
  .ft-card h3 {
    font-size: 20px;
  }
  .ft-card p {
    width: 100%;
  }
  .sub-ct-us {
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
  .sb-card {
    width: 100%;
  }
  .sb-card h4 {
    font-size: 18px;
  }
  .sb-card p {
    font-size: 14px;
  }
  .navigation-dots {
    gap: 15px;
    bottom: 10px;
  }
  .dot {
    width: 12px;
    height: 12px;
  }
  .text-content .title {
    font-size: 2rem;
  }
  .text-content h5 {
    font-size: 1.2rem;
  }
  .text-content li {
    font-size: 1rem;
  }
  .offerings-section h1,
  .rar-section h1,
  .ft-sc h1,
  .ct-us h1 {
    font-size: 2.5rem;
    text-align: center;
  }
  .h-sl2 {
    font-size: 2rem;
  }
  .info-box2 h5 {
    font-size: 1.5rem;
  }
  .info-box2 li {
    font-size: 1.2rem;
  }
  .info-box2 p {
    font-size: 1rem;
  }
  .ib-head-bx h4 {
    font-size: 2rem;
  }
  .underline,
  .underline2 {
    width: 150px;
  }
  .btn3 {
    width: 250px;
    font-size: 18px;
  }
  .mck-cta {
    align-self: center;
  }
  .sub-nic h1 {
    font-size: 64px;
  }
}
/*# sourceMappingURL=product-services.component.css.map */
